// src/constants/EntityConstants.js
// *******************************************************************************
// ENTITY CONSTANTS
// *******************************************************************************
// Centralized constants for entity-related operations
// *******************************************************************************

// *******************************************************************************
// ENTITY PROFILE OPTIONS
// *******************************************************************************
/**
 * Available entity profiles with their colors
 * Used for multi-select in forms and entity categorization
 */
export const ENTITY_PROFILE_COLORS = {
  company: '#3f51b5', // Indigo
  candidate: '#8bc34a', // Light Green
  customer: '#2196f3', // Blue
  supplier: '#673ab7', // Deep Purple
  collaborator: '#ff5722', // Deep Orange
  carrier: '#009688', // Teal
  owner: '#e91e63', // Pink
  system_user: '#607d8b', // Blue Grey
  operator: '#ffc107', // Amber
  contact: '#9c27b0', // Purple
  user: '#ff9800', // Orange
  traveller: '#00bcd4', // Cyan
  subscription: '#4caf50', // Green
  associate: '#03a9f4', // Light Blue
  partner: '#cddc39', // Lime
  opportunity: '#ff4081', // Hot Pink
  organization: '#795548', // Brown
  fallback: '#9e9e9e', // Grey
};

/**
 * Entity profile options for SimpleSelect
 * Formatted for AntD Select component with mode="multiple"
 */
export const ENTITY_PROFILE_OPTIONS = [
  { value: 'customer', labelKey: 'customer', basic: true },
  { value: 'supplier', labelKey: 'supplier', basic: true },
  { value: 'company', labelKey: 'company', basic: false },
  { value: 'contact', labelKey: 'contact', basic: false },
  { value: 'partner', labelKey: 'partner', basic: false },
  { value: 'associate', labelKey: 'associate', basic: false },
  { value: 'collaborator', labelKey: 'collaborator', basic: true },
  { value: 'candidate', labelKey: 'candidate', basic: false },
  { value: 'carrier', labelKey: 'carrier', basic: false },
  { value: 'owner', labelKey: 'owner', basic: false },
  { value: 'traveller', labelKey: 'traveller', basic: false },
  { value: 'operator', labelKey: 'operator', basic: false },
  { value: 'opportunity', labelKey: 'opportunity', basic: false },
  { value: 'organization', labelKey: 'organization', basic: false },
];

/**
 * Common entity profiles for quick selection
 */
export const COMMON_ENTITY_PROFILES = ['customer', 'supplier', 'company', 'contact', 'partner'];

/**
 * Get color for an entity profile
 * @param {string} profile - Entity profile key
 * @returns {string} Color hex code
 */
export function getEntityProfileColor(profile) {
  return ENTITY_PROFILE_COLORS[profile] || ENTITY_PROFILE_COLORS.fallback;
}
